module.exports = __webpack_public_path__ + "static/media/details-10-image-4.ff7fb96d.jpg";